/**
 * DOCUMENT-INTRO-CARD
 * Premiere carte du document unique : ce qu'est le DUERP, et ou le consulter
 */
import Card from "@/components/card"
import HomeButton from "@/components/HomeButton"
import { useRisksSpace } from "@/core/risks-space.context"
import { faLocationDot, faUserFriends } from "@fortawesome/free-solid-svg-icons"
import { useLayoutEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"

const owlImage = require("@/assets/owl-add-task.png")

//Physiques et RPS s'ouvrent depuis leurs cartes
const DOCUMENT_SECTIONS = [
  { path: "/populations", icon: faUserFriends, title: "Fonctions" },
  { path: "/sites", icon: faLocationDot, title: "Lieux de travail" }
]

export default function DocumentIntroCard() {
  const navigate = useNavigate()
  const { getPath } = useRisksSpace()
  const textRef = useRef<HTMLDivElement>(null)
  const [reservedHeight, setReservedHeight] = useState(200)

  useLayoutEffect(() => {
    const text = textRef.current
    if (!text) return
    //La reserve accompagne le texte ; l'image reste ancree a la separation.
    const update = () => setReservedHeight(Math.max(98, text.offsetHeight - 44))
    update()
    const observer = new ResizeObserver(update)
    observer.observe(text)
    return () => observer.disconnect()
  }, [])

  return (
    //Card enveloppe ses enfants dans un PageLoader : c'est lui qui doit prendre la hauteur de la carte
    <Card
      isWithoutPadding
      className="mb-0 box-border flex w-[360px] shrink-0 flex-col overflow-hidden [&>.page-loader]:flex-1 [&>.page-loader>div]:flex [&>.page-loader>div]:h-full">
      <div className="flex flex-1 flex-col">
        <div className="relative flow-root bg-[#EAF2FB] px-[24px] pt-[24px]">
          {/* Le flottant vide laisse les premieres lignes occuper toute la largeur. */}
          <div aria-hidden="true" className="float-left h-[44px] w-0" />
          <div
            aria-hidden="true"
            className="float-left clear-left w-[140px]"
            style={{
              height: reservedHeight,
              //Contour adouci : plus etroit pres de la tete, puis elargi autour de l'aile.
              shapeOutside: "polygon(0 0, 80px 0, 94px 22px, 128px 44px, 128px 66px, 116px 88px, 116px 100%, 0 100%)",
              shapeMargin: "12px"
            }}
          />
          <img alt="" src={owlImage} className="absolute bottom-0 left-[24px] h-auto w-[104px]" />
          <div ref={textRef} className="pb-[24px] text-left text-base leading-[22px] [text-wrap:pretty]">
            Le <b>DUERP</b> (document unique d’évaluation des risques professionnels) recense les risques auxquels les
            collaborateurs sont exposés et les actions de prévention associées.
          </div>
        </div>

        <div className="flex flex-1 flex-col justify-center gap-[12px] p-[24px] [&>.card]:flex-none">
          {DOCUMENT_SECTIONS.map((section) => (
            <HomeButton
              preTitle="Afficher les"
              key={section.path}
              icon={section.icon}
              title={section.title}
              onClick={() => navigate(getPath(section.path))}
            />
          ))}
        </div>
      </div>
    </Card>
  )
}
